var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClasses},[(_vm.getSource != '')?_c('div',{staticClass:"source"},[_vm._v(_vm._s(_vm.$t(_vm.getSource)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }